module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/maestro-old-590ba74305847299b5008642c34d6c05.svg";